import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import '../styles/Dashboard.css';

function Login() {
  const { oktaAuth, authState } = useOktaAuth();

  useEffect(() => {
    if (authState && !authState.isAuthenticated) {
      oktaAuth.signInWithRedirect();
    }
  }, [authState, oktaAuth]);

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Termination Admin</h1>
        <p>Redirecting to Okta...</p>
      </div>
    </div>
  );
}

export default Login;
